import { render, staticRenderFns } from "./DynamicInputModal.vue?vue&type=template&id=2c6fc23e&scoped=true&"
import script from "./DynamicInputModal.vue?vue&type=script&lang=ts&"
export * from "./DynamicInputModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../myvaultspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6fc23e",
  null
  
)

export default component.exports